export const SettingsContent = {
  // Page title
  title: 'Settings',

  // Notification preferences section
  notifications: {
    title: 'Push Notifications',
    description:
      'Choose which notifications should send push alerts. Notifications remain available in your in-app inbox.',
    enableButton: 'Enable Push Notifications',
    enableButtonAriaLabel: 'Enable push notifications for this device',
    preferences: {
      eventReminders: {
        label: 'Event Reminders',
        description: "Get reminded before events you've subscribed to",
      },
      eventChanges: {
        label: 'Event Updates',
        description: 'Be notified when events are updated or cancelled',
      },
      communityComments: {
        label: 'Community Comments',
        description: 'Get alerted when someone comments on your post',
      },
    },
    testNotification: {
      button: 'Send Test Notification',
      buttonSending: 'Sending in {seconds}s...',
      buttonSent: 'Notification Sent!',
      description: 'Send a test notification to verify your setup',
      ariaLabel: 'Send a test push notification to this device',
      askAdminIfNoNotificationReceived:
        "If you don't receive a notification, please contact your administrator for help.",
    },
  },

  // Notification prompt card
  notificationPrompt: {
    title: "Notifications aren't enabled",
    description:
      'For the best experience, enable notifications to stay updated on events and updates.',
    enableButton: 'Enable Notifications',
    laterButton: 'Later',
    dismissAriaLabel: 'Dismiss notification prompt',
  },

  // Storage section
  storage: {
    title: 'Storage',
    description:
      "Clear cached data to free up space or resolve issues. This will remove offline data but won't affect your account.",
    clearCache: {
      button: 'Clear Cache',
      buttonClearing: 'Clearing...',
      success: 'Cache cleared successfully!',
      error: 'Failed to clear cache. Please try again.',
      description:
        'Remove all cached data including offline assets and stored app data.',
    },
  },
} as const;
